var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showLayout)?_c('MenuHeader'):_vm._e(),(_vm.showLayout)?_c('MenuAside'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }